import { cn } from "@/lib/utils"

interface EyebrowProps {
	children: React.ReactNode
	/** Ubicación del bloque: izquierda (por defecto), centro o derecha. */
	align?: "left" | "center" | "right"
	className?: string
}

const ALIGN: Record<NonNullable<EyebrowProps["align"]>, string> = {
	left: "text-left",
	center: "text-center",
	right: "text-right"
}

/**
 * Etiqueta pequeña ("eyebrow") que precede al título de una sección: texto en
 * color primary con una línea de 1px difuminada debajo, del ancho del texto.
 * Mismo estilo que el eyebrow del Hero de inicio; reutilizable en todas las
 * secciones. `align` ubica el bloque (izquierda por defecto, centro o derecha).
 */
export function Eyebrow({ children, align = "left", className }: EyebrowProps): React.JSX.Element {
	return (
		<div className={cn(ALIGN[align], className)}>
			<span className="inline-block">
				<span className="text-sm font-medium text-primary">{children}</span>
				<span aria-hidden className="mt-2 block h-px w-full bg-linear-to-r from-transparent via-primary to-transparent" />
			</span>
		</div>
	)
}
